import {
  exposureCategoryOptions,
  type ExposureItemCategory,
} from '../../../data/foods';

export type QuickConfigAppType = 'exposure' | 'performance' | 'body_image';

export type ExposureCategorySelection = Record<ExposureItemCategory, boolean>;

export type QuickConfigDevices = {
  deviceId: string;
  sensorId?: string;
};

export type ExposureQuickFormState = {
  map: string;
  userSpawnPosition: string;
  hasTutorial: boolean;
  multiItem: boolean;
  categories: ExposureCategorySelection;
};

export type PerformanceQuickFormState = {
  map: string;
  currentState: string;
  variation: number;
  duration: number;
};

export type BodyImageQuickFormState = Record<string, never>;

export const DEFAULT_EXPOSURE_CATEGORIES: ExposureCategorySelection = {
  food: true,
  alcohol: false,
  drug: false,
  device: false,
};

export const EXPOSURE_CATEGORY_OPTIONS = exposureCategoryOptions;
